import React from "react";
import "./index.scss";
import Drawer from "devextreme-react/drawer";
import { IMdaeDrawerOption } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

const MdaeDrawer: React.FC<IMdaeDrawerOption> = (props) => {
  const dispatch = useDispatch();
  return (
    <Drawer
      {...props}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_DRAWER,
          e.component,
          dispatch
        );
      }}
    >
      {props.children}
    </Drawer>
  );
};
export default MdaeDrawer;
